import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { styled, Tabs } from '@mui/material';
import { pxToRem } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTabs = styled(function (props) {
  return /*#__PURE__*/_jsx(Tabs, _objectSpread({}, props));
}, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'viewVariant';
  }
})(function (_ref) {
  var theme = _ref.theme,
    viewVariant = _ref.viewVariant,
    size = _ref.size;
  var styles = {
    minHeight: 'initial',
    '& .MuiTabs-indicator': {
      backgroundColor: theme.colors.mirage,
      bottom: pxToRem(0)
    }
  };
  switch (size) {
    case 'small':
      {
        styles = _objectSpread(_objectSpread({}, styles), {
          '& .MuiTabs-indicator': {
            bottom: pxToRem(20),
            backgroundColor: theme.colors.mirage
          }
        });
        break;
      }
    default:
      {
        break;
      }
  }
  switch (viewVariant) {
    case 'contained':
      {
        styles = _objectSpread(_objectSpread({}, styles), {
          '& .MuiTabs-indicator': {
            backgroundColor: 'transparent',
            bottom: '0'
          }
        });
        break;
      }
    default:
      {
        break;
      }
  }
  return styles;
});
export { StyledTabs };